import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { ClientRiskLevelModalTrigger } from './ClientRiskLevelModal'

export { ClientRiskLevelModalTrigger }

export default Loadable(() => import('./ClientRiskLevelModal'))
